import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import { useButtonProps } from "../hooks/useButtonProps";

import "../styles/components/CarouselItem.scss";

const CarouselItem = ({ title, media, ctaLink, ctaText, pdf }) => {
    const buttonProps = useButtonProps({ link: ctaLink, asset: pdf });

    return (
        <div className="carousel-item">
            <GatsbyImageWithSVGSupport className="image ratio ratio-16x9" image={media} />
            <div className=" d-flex flex-column px-4 mt-4">
                <h5>{title}</h5>
            </div>
            <Button
                variant="link"
                className="d-flex mt-auto px-4 pb-4"
                {...buttonProps}
            >
                {ctaText || "Read More"} &rarr;
            </Button>
        </div>
    );
};

CarouselItem.propTypes = {
    title: PropTypes.string.isRequired,
    media: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        gatsbyImageData: PropTypes.object,
        file: PropTypes.shape({
            contentType: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    }),
    pdf: PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }),
    ctaText: PropTypes.string,
    ctaLink: PropTypes.string.isRequired,
};

export default CarouselItem;
